import { type AwardedBadge } from './badges';

/** Sample `awarded_badges` for the mock `/user/v1/badges` response (Storybook only). */
export const MOCK_AWARDED_BADGES: AwardedBadge[] = [
  {
    badge_id: 'active_ninja',
    badge_name: 'Active Ninja',
    type: 'manual',
    category: 'In-Class',
    celebrated: true,
    awarded_count: 2,
    awarded_on: 1_779_099_166,
    awarded_by: 'ishan.jain@expinfi.com',
    module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
    module_awards: [
      {
        module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
        module_name: 'Module 3 - Understanding The Number System',
        awarded_count: 2,
      },
    ],
  },
  {
    badge_id: 'brainy_bee',
    badge_name: 'Brainy Bee',
    type: 'manual',
    category: 'In-Class',
    celebrated: true,
    awarded_count: 2,
    awarded_on: 1_779_099_974,
    awarded_by: 'ishan.jain@expinfi.com',
    module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
    module_awards: [
      {
        module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
        module_name: 'Module 3 - Understanding The Number System',
        awarded_count: 2,
      },
    ],
  },
  {
    badge_id: 'einstein_spark',
    badge_name: 'Einstein Spark',
    type: 'manual',
    category: 'In-Class',
    celebrated: true,
    awarded_count: 6,
    awarded_on: 1_779_727_421,
    awarded_by: 't.1618999@expinfi.com',
    module_id: '',
    module_awards: [],
  },
  {
    badge_id: 'first_step',
    badge_name: 'First Step',
    type: 'auto',
    category: 'Early Momentum',
    celebrated: true,
    awarded_count: 1,
    awarded_on: 1_777_533_727,
    awarded_by: 'system',
    module_id: 'module-001-a',
    module_awards: [
      {
        module_id: 'module-001-a',
        module_name: 'Module 1 - Understanding The Number System',
        awarded_count: 1,
      },
    ],
  },
  {
    badge_id: 'joyful_jupiter',
    badge_name: 'Joyful Jupiter',
    type: 'manual',
    category: 'In-Class',
    celebrated: true,
    awarded_count: 2,
    awarded_on: 1_779_099_974,
    awarded_by: 'ishan.jain@expinfi.com',
    module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
    module_awards: [
      {
        module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
        module_name: 'Module 3 - Understanding The Number System',
        awarded_count: 2,
      },
    ],
  },
  {
    badge_id: 'kind_koala',
    badge_name: 'Kind Koala',
    type: 'manual',
    category: 'In-Class',
    celebrated: true,
    awarded_count: 4,
    awarded_on: 1_779_727_421,
    awarded_by: 't.1618999@expinfi.com',
    module_id: '',
    module_awards: [],
  },
  {
    badge_id: 'rising_star',
    badge_name: 'Rising Star',
    type: 'manual',
    category: 'Special Recognition',
    celebrated: true,
    awarded_count: 2,
    awarded_on: 1_779_099_166,
    awarded_by: 'ishan.jain@expinfi.com',
    module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
    module_awards: [
      {
        module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
        module_name: 'Module 3 - Understanding The Number System',
        awarded_count: 2,
      },
    ],
  },
  {
    badge_id: 'ryan_jr',
    badge_name: 'Ryan Jr',
    type: 'manual',
    category: 'In-Class',
    celebrated: true,
    awarded_count: 1,
    awarded_on: 1_777_538_609,
    awarded_by: 'ishan.jain@expinfi.com',
    module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
    module_awards: [
      {
        module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
        module_name: 'Module 3 - Understanding The Number System',
        awarded_count: 1,
      },
    ],
  },
  {
    badge_id: 'streak_warrior',
    badge_name: 'Streak Warrior',
    type: 'auto',
    category: 'Attendance Consistency',
    celebrated: true,
    awarded_count: 1,
    awarded_on: 1_779_101_154,
    awarded_by: 't.1618999@expinfi.com',
    module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
    module_awards: [
      {
        module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
        module_name: 'Module 3 - Understanding The Number System',
        awarded_count: 1,
      },
    ],
  },
  {
    badge_id: 'super_simba',
    badge_name: 'Super Simba',
    type: 'manual',
    category: 'In-Class',
    celebrated: true,
    awarded_count: 13,
    awarded_on: 1_778_851_748,
    awarded_by: 'trainer_tgp@expinfi.com',
    module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
    module_awards: [
      {
        module_id: '264d6f00-ad1f-4c0e-9979-c391df883631',
        module_name: 'Module 3 - Understanding The Number System',
        awarded_count: 11,
      },
      {
        module_id: '9a0dff51-e972-4491-9072-4310bcda09a3',
        module_name: 'Mastering Tables',
        awarded_count: 2,
      },
    ],
  },
];
